import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CategorieModel } from 'src/models/categorieModel';

@Injectable({
  providedIn: 'root'
})
export class CategorieService {
  private baseUrl = environment.api_LMS + 'Categorie';

  constructor(private http: HttpClient) { }

  obtenirCategories(): Observable<CategorieModel[]> {
    return this.http.get<CategorieModel[]>(`${this.baseUrl}/ObtenirCategories`);
  }
}